import { useState } from 'react';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import { CheckCircleOutline, ThumbDown, ThumbUp } from '@mui/icons-material';
import React from 'react';
import Button from '@mui/material/Button';

interface Props {
    requestId: string;
    submitFeedback: (isPositive: boolean, requestId: string, feedbackText?: string) => Promise<boolean>;
}

const MessageFeedback: React.FC<Props> = ({ requestId, submitFeedback }) => {
    const [status, setStatus] = useState<'' | 'up' | 'down'>('');
    const [comment, setComment] = useState('');

    const handleVote = async (isUp: boolean) => {
        if (isUp) {
            const success = await submitFeedback(true, requestId);
            if (success) setStatus('up');
        } else {
            setStatus('down');
        }
    };

    const handleSendComment = async () => {
        const success = await submitFeedback(false, requestId, comment);
    };

    return (
        <Box sx={{ mt: 1, borderTop: '1px solid', borderColor: 'grey.100', pt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', mr: 1, fontSize: '11px' }}>
                    Was this helpful?
                </Typography>

                <IconButton
                    size="small"
                    onClick={() => handleVote(true)}
                    sx={{ color: status === 'up' ? 'success.main' : 'grey.400' }}
                >
                    <ThumbUp sx={{ fontSize: 16 }} />
                </IconButton>

                <IconButton
                    size="small"
                    onClick={() => handleVote(false)}
                    sx={{ color: status === 'down' ? 'error.main' : 'grey.400' }}
                >
                    <ThumbDown sx={{ fontSize: 16 }} />
                </IconButton>
            </Box>

            {status === 'down' && (
                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        placeholder="How can we improve?"
                        variant="outlined"
                        size="small"
                        value={comment}
                        autoFocus
                        onChange={(e) => setComment(e.target.value)}
                        sx={{
                            bgcolor: 'grey.50',
                            '& .MuiOutlinedInput-root': {
                                fontSize: '13px',
                                lineHeight: '1.5',
                                padding: '8px 12px',
                            },
                        }}
                    />
                    <Button
                        variant="contained"
                        size="small"
                        disableElevation
                        onClick={handleSendComment}
                        sx={{ alignSelf: 'flex-end', textTransform: 'none', fontSize: '12px' }}
                    >
                        Send
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default MessageFeedback;
